'use client'

import { useMutation } from "@tanstack/react-query"
import { API_Error } from "@/interfaces/api/response/api_response_types"
import { API_Data_Free_Trial_Response } from "@/interfaces/api/purchases/api_response_types"
import { freeTrial } from "../requests/purchases"

export const useFreeTrial = () => useMutation<API_Data_Free_Trial_Response, API_Error>({
  retry: false,
  mutationFn: freeTrial
})